export default __webpack_public_path__ + "static/media/whiteFront1.3fb3f6f3.png";